import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaPizzaSlice, FaUtensils, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaMotorcycle, FaMapMarkerAlt } from 'react-icons/fa';

const WebPizzeriaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-restaurantes", text: "Página web barata para restaurantes" },
    { url: "/servicios/diseno-web-cafeteria", text: "Página web barata para cafeterías" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Recibe pedidos incluso fuera de horario",
      description: "Tu web trabaja 24/7, captando pedidos en cualquier momento. Los clientes pueden conocer tu carta y hacer pedidos incluso cuando no estás abierto."
    },
    {
      title: "Ahorra costes en comisiones",
      description: "Evita el 20-30% de comisión que cobran plataformas como Just Eat o Glovo. Recibe pedidos directamente sin intermediarios ni costes adicionales."
    },
    {
      title: "Muestra tu carta de forma visual",
      description: "Presenta tus pizzas con fotografías profesionales que abren el apetito. Las imágenes de calidad aumentan un 43% las ventas en el sector hostelero."
    },
    {
      title: "Posiciónate localmente en Google",
      description: "Aparece cuando buscan 'pizzería en [tu barrio/ciudad]'. El 92% de las búsquedas de restaurantes incluyen términos de proximidad."
    },
    {
      title: "Diferénciate de la competencia",
      description: "El 64% de las pizzerías locales no tienen presencia online profesional. Destaca con una web moderna que muestre tus especialidades e ingredientes de calidad."
    },
    {
      title: "Recupera la inversión en semanas",
      description: "Con solo 7-8 pedidos directos (sin comisiones de plataformas) a la semana, recuperas la inversión en menos de dos meses."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaPizzaSlice />,
      title: "Carta digital visual",
      description: "Presentación atractiva de tus pizzas y platos con fotografías profesionales. Categorías claras, descripciones apetitosas y precios actualizables."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 76% de los pedidos online se realizan desde dispositivos móviles. Tu web se verá perfecta en cualquier tamaño de pantalla."
    },
    {
      icon: <FaMotorcycle />,
      title: "Información de reparto y recogida",
      description: "Sección clara con zonas de reparto, tiempos estimados y opción de recogida en local. Fundamental para gestionar expectativas de los clientes."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización SEO local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Destaca cuando busquen 'pizzerías cerca' o en tu barrio específico."
    },
    {
      icon: <FaUtensils />,
      title: "Presentación de especialidades",
      description: "Sección destacada para tus pizzas especiales, ingredientes premium o técnicas artesanales. Diferénciate de las cadenas genéricas."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para pizzerías",
      description: "Posicionamiento para términos como 'mejor pizzería en [tu zona]', 'pizza artesanal' o 'reparto de pizza a domicilio'. Atrae a tu público local."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Pizzería Básica',
      price: 200,
      period: 'pago único',
      description: 'Ideal para pizzerías que quieren iniciar su presencia digital profesional.',
      features: [
        { text: 'Hasta 5 páginas principales', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carta digital básica', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Información de horarios y ubicación', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Optimización Google Maps', included: true },
        { text: 'Sistema de pedidos online', included: false },
        { text: 'Optimización SEO avanzada', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=pizzeria-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Pizzería Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más elegida. Web completa con todas las funcionalidades para pizzerías que quieren crecer.',
      features: [
        { text: 'Entre 5-10 páginas', included: true },
        { text: 'Adaptada a todos los dispositivos', included: true },
        { text: 'Carta digital completa con imágenes', included: true },
        { text: 'Sección de especialidades', included: true },
        { text: 'Información detallada de delivery', included: true },
        { text: 'Integración con redes sociales', included: true },
        { text: 'Optimización SEO local', included: true },
        { text: 'Galería de fotos profesional', included: true },
        { text: 'Sistema de pedidos online*', included: false },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=pizzeria-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Pizzería Premium',
      price: 400,
      period: 'pago único',
      description: 'Solución completa para pizzerías que buscan una experiencia digital de alto nivel.',
      features: [
        { text: 'Entre 10-15 páginas', included: true },
        { text: 'Diseño exclusivo personalizado', included: true },
        { text: 'Carta interactiva premium', included: true },
        { text: 'Página de historia y proceso', included: true },
        { text: 'Galería profesional con categorías', included: true },
        { text: 'Multiidioma (2 idiomas)', included: true },
        { text: 'Blog de recetas o noticias', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Sistema avanzado de pedidos*', included: false },
        { text: 'Marketing digital inicial', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=pizzeria-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu pizzería, carta, especialidades y zona de reparto. Planificamos una web que refleje tu estilo y atraiga a clientes de tu zona.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño atractivo que abra el apetito. Implementamos tu carta, información de reparto y todas las secciones necesarias.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes de tu zona de reparto.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para pizzerías",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Carta actualizable fácilmente",
      us: true,
      others: false
    },
    {
      label: "Fotos profesionales optimizadas",
      us: true,
      others: false
    },
    {
      label: "Sin comisiones por pedidos",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Antes éramos completamente dependientes de plataformas como Just Eat y Glovo, que se llevaban un 25% de cada pedido. Desde que lanzamos nuestra web, hemos conseguido que un 40% de los pedidos vengan directamente, sin intermediarios ni comisiones. Nuestros clientes habituales prefieren usar nuestra web porque es más rápida y personalizada. Además, nos permite destacar nuestras especialidades y proceso artesanal, algo que no podíamos hacer en las plataformas. La inversión se amortizó en menos de 6 semanas gracias al ahorro en comisiones.",
    author: "Roberto Bianchi",
    position: "Propietario",
    company: "Pizzería Napolitana",
    avatar: "/servicios/testimonios/pizzeria.webp"
  };
  
  const founderMessage = "En el competitivo sector de la restauración y delivery, las pizzerías independientes están perdiendo gran parte de sus beneficios en comisiones a grandes plataformas. Desarrollamos webs que les devuelven el control sobre sus pedidos y márgenes, creando una experiencia visual que destaca lo que realmente les diferencia: sus especialidades, su proceso artesanal y su personalidad única.";
  
  // FAQs específicas para web de pizzerías
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi pizzería?",
      answer: "Una web profesional es clave para las pizzerías actuales por varios motivos estratégicos: 1) Te independiza de plataformas de delivery que cobran entre 20-30% de comisión por pedido; 2) El 76% de los clientes buscan restaurantes online antes de decidir dónde pedir; 3) Permite mostrar tu carta completa con fotografías de calidad que abren el apetito; 4) Te posiciona en Google Maps y búsquedas locales como 'pizzería cerca de mí', fundamentales para el negocio local; 5) Diferencia tu pizzería de la competencia destacando especialidades, ingredientes artesanales o métodos de elaboración; 6) Proporciona información actualizada de horarios, zonas de reparto y precios 24/7; 7) Facilita la fidelización de clientes a través de promociones exclusivas web. Según datos del sector, las pizzerías con web propia y sistema de pedidos integrado incrementan su facturación entre un 15-35% en los primeros seis meses, principalmente por el ahorro en comisiones y la captación de nuevos clientes.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrará mi carta en la web?",
      answer: "Tu carta se presentará de forma visual y atractiva con estas características: 1) Organización por categorías (pizzas tradicionales, especiales, entrantes, bebidas, postres) para facilitar la navegación; 2) Fotografías profesionales optimizadas que muestren tus productos con la mejor apariencia; 3) Descripciones detalladas de ingredientes, con posibilidad de destacar productos locales o artesanales; 4) Indicadores visuales para opciones vegetarianas, veganas o sin gluten; 5) Precios claramente visibles con opción de destacar promociones; 6) Diseño responsive que asegura perfecta visualización en móviles; 7) Posibilidad de destacar tus especialidades o las pizzas más populares en secciones especiales. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar fácilmente precios, añadir o eliminar platos, o modificar descripciones. Para pizzerías con carta que cambia frecuentemente o con ofertas del día, podemos implementar secciones específicas fácilmente actualizables.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de pedidos online?",
      answer: "Los sistemas de pedidos online no están incluidos en los precios base y se presupuestan aparte según tus necesidades específicas: 1) Sistema básico de pedidos (desde 150€) - Formulario con selección de productos, datos de entrega y método de pago contra entrega; 2) Sistema intermedio (desde 250€) - Plataforma con carrito de compra, seguimiento de pedido y posibilidad de pago online; 3) Sistema avanzado (desde 400€) - Sistema completo con gestión de zonas de reparto, cálculo automático de costes de envío, tiempos estimados y múltiples formas de pago. Estos sistemas se integran con tu web y te permiten recibir pedidos sin pagar comisiones a plataformas externas (que suelen cobrar entre 20-30% por pedido). Para pizzerías que ya utilizan un sistema específico, podemos integrar tu web con plataformas como Gloria Food, MenuDrive u otras. El presupuesto exacto se determina tras analizar tus necesidades, volumen de pedidos y zona de reparto.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas para mantener la relación calidad-precio: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, carta, información de reparto, sobre nosotros y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como promociones especiales, proceso de elaboración, ingredientes de calidad, o galería multimedia; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo incluir blog de recetas, historia de la pizza, información nutricional, eventos o catering, y contenido en varios idiomas. Si necesitas más páginas de las incluidas en tu plan, tienen un coste adicional de 40€ por página. Para webs más extensas, recomendamos solicitar un presupuesto personalizado. La mayoría de pizzerías obtienen excelentes resultados con el número de páginas incluido en los planes estándar, ya que la prioridad es tener una carta clara y un sistema de pedidos eficiente.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos utilizaréis en mi web?",
      answer: "Las imágenes son cruciales para una web de pizzería efectiva, ya que las fotos de calidad pueden aumentar los pedidos hasta un 30%. Tienes estas opciones: 1) Fotografías propias: Si dispones de imágenes profesionales de tus pizzas y local, las optimizaremos para web manteniendo la calidad; 2) Sesión fotográfica profesional: Te recomendamos fotógrafos especializados en gastronomía que pueden realizar una sesión completa (presupuesto aproximado: 200-300€); 3) Imágenes mixtas: Combinación de tus mejores fotos actuales con algunas imágenes de stock seleccionadas; 4) Consejos fotográficos: Te ofrecemos una guía para que puedas tomar mejores fotos con tu smartphone hasta realizar una sesión profesional. Recomendamos especialmente invertir en fotografías de tus pizzas más populares, ya que estas imágenes son determinantes para la primera impresión y la decisión de compra. Las webs de pizzerías con fotografías profesionales generan hasta un 40% más de conversiones que aquellas con imágenes de baja calidad.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye todos los aspectos técnicos necesarios: 1) Alojamiento en servidores de alta velocidad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionamos acceso a un panel intuitivo donde podrás actualizar la carta, precios, promociones, zonas de reparto y horarios especiales. Para pizzerías es especialmente útil poder actualizar rápidamente ofertas temporales, platos del día o cambios en la disponibilidad. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos. Si añades un sistema de pedidos online, este podría tener un coste de mantenimiento adicional según su complejidad.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para pizzerías
      pageTitle="Web para Pizzerías desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para pizzerías. Carta digital atractiva, información de reparto y posicionamiento local para atraer más clientes en tu zona."
      pageKeywords="página web barata pizzería, web para pizzerías, diseño web pizza, página web pizzería barata, web pizzería económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-pizzeria"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para pizzerías desde 200€ (sin comisiones por pedido)"
      heroSubtitle="Diseñamos webs para pizzerías que destacan tu carta y aumentan los pedidos. Sistema de pedidos online, menú digital actualizable y optimización para móviles."
      heroImage="/servicios/tipo-cliente/hero-pizzeria.webp"
      badges={['Desde 200€ (pago único)', 'Pedidos online', 'Carta digital', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para pizzerías"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes. *Sistemas de pedidos online presupuestados aparte."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para pizzerías?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Miguel Vela"
          founderTitle="Co-fundador y Director de Desarrollo"
          avatarSrc="/sobre nosotros/foto-miguel.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de pizzería?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu pizzería"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para pizzerías"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu pizzería con presencia online profesional"
      ctaDescription="Una inversión inteligente que te liberará de comisiones, mostrará tus especialidades y atraerá más clientes directos. Recupera la inversión en pocas semanas."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebPizzeriaPage; 

